module.exports = __webpack_public_path__ + "static/media/wallet.7b312249.svg";